<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="Company Data"
            text="List of Companies"
          >
            <v-spacer/>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              placeholder="Search by Name"
              clearable
              single-line
              hide-details/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="720px">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="hasPermission('MA_MD_COMPANY_READ') === true"
                  :dark="hasPermission('MA_MD_COMPANY_READ') === false"
                  color="general"
                  class="mb-2 ml-1 mr-1"
                  v-on="on">New
                </v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md >
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="[rules.required,rules.max50chars]"
                            label="Company Name *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.phone"
                            :rules="[rules.number, rules.max50chars]"
                            label="Phone No"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.industry"
                            label="Industry"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md8>
                          <v-textarea
                            v-model="editedItem.address.street"
                            :rules="[rules.required]"
                            label="Address Street *"
                            clearable/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.address.zipCode"
                            :rules="[rules.number]"
                            label="Zip Code"/>
                        </v-flex>

                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="close">Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="green darken-1"
                      flat
                      @click="save">Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-btn
              :disabled="hasPermission('MA_MD_COMPANY_READ') === true"
              :dark="hasPermission('MA_MD_COMPANY_READ') === false"
              color="general"
              class="mb-2"
              @click="$refs.downloadExcel.generate()"
            >
              <download-excel
                ref="downloadExcel"
                :fetch="fetchData"
                :fields="excelFields"
                :before-generate="showProgressBar"
                :before-finish="hideProgressBar"
                class="btn btn-default"
                worksheet="worksheet"
                name="Company-All.xls">
                <v-icon>mdi-file-excel</v-icon>&nbsp;
              </download-excel>Export All
            </v-btn>
            <v-btn
              :disabled="selectFileDisabled || hasPermission('MA_MD_COMPANY_READ') === true"
              :dark="hasPermission('MA_MD_COMPANY_READ') === false"
              class="mb-2 ml-1 mr-1"
              color="general"
              @click="$refs.inputUpload.click()">
              Select&nbsp;<v-icon>mdi-file-excel</v-icon>
            </v-btn>
            <input
              v-show="false"
              ref="inputUpload"
              type="file"
              @change="loadFile"
            >
            <v-chip
              v-show="showFilename"
              class="ma-1"
              color="general"
              label
              outline
            >
              <v-icon left>mdi-file-check</v-icon>
              {{ file.name }}
            </v-chip>
            <v-btn
              :loading="uploadFileLoading"
              :disabled="uploadFileDisabled"
              :dark="!uploadFileDisabled"
              color="general"
              class="mb-2 ml-1 mr-1"
              @click="uploadFile">Upload&nbsp;
              <v-icon>mdi-upload</v-icon>
            </v-btn>
            <v-dialog
              v-model="dialogDelete"
              max-width="400px">
              <v-card>
                <v-card-title class="headline">System Message Confirmation</v-card-title>
                <v-card-text>
                  Are you sure want to remove this data? <br>
                  "{{ deleteItemRecord.name }}"
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>

                  <v-btn
                    color="red darken-1"
                    text
                    flat
                    @click="dialogDelete = false"
                  >
                    Cancel
                  </v-btn>

                  <v-btn
                    color="green darken-1"
                    text
                    flat
                    @click="deleteItem(deleteItemRecord)"
                  >
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-progress-linear
              v-show="uploadFileLoading"
              :indeterminate="true"/>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="DataList"
              :pagination.sync="pagination"
              :rows-per-page-items="rowsAmount"
              :total-items="totalRows"
              dense
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props" >
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    medium
                    @click="dialogDeleteShow(props.item)">delete
                  </v-icon>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.address.street }}</td>
                <td>{{ props.item.phone }}</td>
                <td>{{ props.item.address.zipCode }}</td>
                <td>{{ props.item.industry }}</td>
                <td>{{ props.item.lastUpdateBy }}</td>
                <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close
              </v-btn>
            </v-snackbar>

            <v-dialog
              v-model="dialogUploadFinish"
              scrollable
              persistent
              max-width="480px">
              <v-card>
                <v-card-title class="headline">Import Excel Information</v-card-title>
                <v-card-text>
                  <div
                    class="body-1"
                    style="white-space: pre;">{{ uploadResponse.errMessage }}</div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="green darken-1"
                    text
                    flat
                    @click="dialogUploadFinish = false"
                  >
                    OK
                  </v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [displayFormatterMixins],
    data: () => ({
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: {},
      DataList: [],
      totalRows: 0,
      checkboxAdmin: true,
      checkboxActive: true,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogDelete: false,
      deleteItemRecord: {},
      loading: true,
      search: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Company Name', value: 'name' },
        { text: 'Address', value: 'address.street' },
        { text: 'Telephone No.', value: 'phone' },
        { text: 'Zip Code', value: 'address.zipCode' },
        { text: 'Industry', value: 'industry' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' }
      ],
      excelFields:
        {
          'Company Name (*)': 'name',
          'Address (*)': 'address.street',
          'Telp (*)': {
            field: 'phone',
            callback: value => `="${value}"`
          },
          'Zip Code (*)': 'address.zipCode',
          'Industry (*)': 'industry',
          'Update By': 'lastUpdateBy',
          'Update Date Time': {
            callback: (value) => {
              return new Date(value.lastUpdateDate).toLocaleString('en-GB')
            }
          }
        },
      companies: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        address: {
          street: '',
          zipCode: ''
        },
        industry: '',
        phone: '',
        isActive: true
      },
      defaultItem: {
        id: null,
        name: '',
        address: {
          street: '',
          zipCode: ''
        },
        phone: '',
        industry: '',
        isActive: true,
        lastUpdateDate: '',
        lastUpdateBy: ''
      },
      file: {},
      selectFileDisabled: false,
      uploadFileDisabled: true,
      dialogUploadFinish: false,
      uploadResponse: {},
      uploadFileLoading: false,
      showFilename: false
    }),
    computed: {
      ...mapGetters(['hasPermission']), // without modules
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination: {
        async handler () {
          console.debug('pagination watcher')
          this.getCompanies()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetCompanies()
      }
    },
    // called when page is created before dom
    created () {
      this.debouncedGetCompanies = _.debounce(this.getCompanies, 500)
    },

    methods: {
      async getCompanies () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search
          console.debug(this.pagination)
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/company?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async fetchData () {
        const response = await this.$http.get(`/api/company/all`)
        return response.data
      },
      showProgressBar () {
        this.uploadFileLoading = true
      },
      hideProgressBar () {
        this.uploadFileLoading = false
      },
      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        item.isAdmin = this.checkboxAdmin
        item.isActive = this.checkboxActive
        this.editedItem = Object.assign({}, item)
        this.dialog = dbox
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/company/${rec.id}`
        let method = 'delete'
        let s = {}
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => {
            if (response.data.message == 'FAILED') {
              this.cancelInline(response.data.details)
            } else {
              this.DataList.splice(this.DataList.indexOf(rec), 1)
              this.deleteInline()
            }
          })
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (!this.$refs.form.validate()) {
          console.log('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.log('validation success')
        }

        if (this.editedIndex > -1) {
          let tableItem = this.editedItem
          let endpoint = `api/company/${this.editedItem.id}`
          let method = 'patch'
          let index = this.editedIndex
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message == 'FAILED') {
                this.cancelInline(response.data.details)
              } else {
                Object.assign(this.DataList[index], response.data)
                this.saveInline()
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          let endpoint = `api/company`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message === 'FAILED') {
                this.cancelInline(response.data.details)
              } else {
                this.saveInline()
                this.DataList.push(response.data)
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()
      },
      async loadFile (e) {
        /** Load same file would not work!! @change event **/
          // const files = e.target.files
        const fileref = this.$refs.inputUpload.files
        console.debug(fileref.length)
        if (fileref[0] == undefined || fileref[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.fileFormatSnack()
          return
        }
        if (fileref[0] !== undefined) {
          console.debug(fileref[0].name)
          console.debug('Type: ' + fileref[0].type)
          console.debug('Size: ' + fileref[0].size + ' bytes')
          const fr = new FileReader()
          fr.readAsDataURL(fileref[0])
          fr.addEventListener('load', async () => {
            // console.debug(fr.result)
            // this.imageFile = files[0] // this is an image file that can be sent to server...
            // let response = await this.$store.dispatch('uploadFile', { file, endpoint })
            // console.debug(response)
            this.file = fileref[0]
            this.showFilename = true
            this.uploadFileDisabled = false
          })
        } else {
          this.file = {}
        }
      },
      async uploadFile () {
        let endpoint = 'api/excel/company'
        let filexls = this.file
        console.debug(this.file)
        try {
          this.uploadFileLoading = true
          this.uploadFileDisabled = true
          this.selectFileDisabled = true
          let response = await this.$store.dispatch('uploadFile', { filexls, endpoint })
          if (response.data.message == 'FAILED') {
            this.cancelInline(response.data.details)
            return
          }
          this.uploadResponse = response.data
          console.log(this.uploadResponse)
          this.dialogUploadFinish = true
          this.getCompanies()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.showFilename = false
        this.uploadFileLoading = false
        this.selectFileDisabled = false
        this.file = {}
        this.$refs.inputUpload.value = '' // make sure it is free from file object
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (txt) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = txt || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      },
      fileFormatSnack () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Please select xls/xlsx file'
      }
    }
  }
</script>

<style scoped>

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
</style>
